import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { buildSealSvg, type SealStyle } from './sealModel';

/**
 * Reads whether this Association keeps a seal, and holds the steward's choice
 * to apply it on this set of papers. When the Association keeps no seal,
 * nothing shows and nothing renders.
 */
export function useAssociationSeal(unaId?: string | null) {
  const [name, setName] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [style, setStyle] = useState<SealStyle | null>(null);
  const [applySeal, setApplySeal] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!unaId) return;
      const { data } = await supabase
        .from('unas')
        .select('name, seal_enabled, seal_style')
        .eq('id', unaId)
        .maybeSingle();
      if (cancelled || !data) return;
      setName((data as any).name || '');
      setEnabled(Boolean((data as any).seal_enabled));
      setStyle(((data as any).seal_style as SealStyle | null) ?? null);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [unaId]);

  const applied = enabled && applySeal;

  return {
    /** True when the Association keeps a seal at all. */
    sealAvailable: enabled,
    applySeal,
    setApplySeal,
    /** What the builders read. */
    sealEnabled: applied,
    sealSvg: applied ? buildSealSvg(name, style) : undefined,
  };
}
